import React from 'react';
import { Link, useStaticQuery } from 'gatsby';
import { Box, Button } from '@chakra-ui/react';
import { MdOutlineContactPhone } from 'react-icons/md';
import OpeningPeriods from './OpeningPeriods';
import './styles.css';
import Heading from '../../@interness/web-core/components/text/Heading/Heading';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CallToAction = _ref => {
  let {
    heading,
    description,
    button,
    link,
    imageFileTitle
  } = _ref;
  const data = useStaticQuery(query);
  const image = data.directusGlobalMediaCollection.media.find(media => media.file.title.toLowerCase().trim() === imageFileTitle.toLowerCase().trim()).file.localFile.publicURL;
  const defaultImages = {
    desktop: image,
    mobile: image
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Heading, {
    tag: 'h2',
    icon: ___EmotionJSX(MdOutlineContactPhone, null)
  }, heading), ___EmotionJSX(Box, {
    id: "cta-262",
    sx: {
      color: '#fff !important',
      'h2,h4': {
        color: '#fff'
      },
      h4: {
        fontWeight: 'bold !important'
      }
    }
  }, ___EmotionJSX("div", {
    className: "cs-container"
  }, ___EmotionJSX("div", {
    className: "cs-left-section"
  }, ___EmotionJSX("h2", {
    className: "cs-title"
  }, description), ___EmotionJSX(Button, {
    colorScheme: "brand",
    as: Link,
    to: link,
    sx: {
      textDecoration: 'none'
    }
  }, button)), ___EmotionJSX("div", {
    className: "cs-content"
  }, ___EmotionJSX(OpeningPeriods, {
    openingPeriods: data.allDirectusOpeningPeriods.nodes
  })), ___EmotionJSX("picture", {
    className: "cs-background"
  }, ___EmotionJSX("source", {
    media: "(max-width: 600px)",
    srcSet: defaultImages.mobile
  }), ___EmotionJSX("source", {
    media: "(min-width: 601px)",
    srcSet: defaultImages.desktop
  }), ___EmotionJSX("img", {
    "aria-hidden": "true",
    loading: "lazy",
    decoding: "async",
    src: defaultImages.mobile,
    alt: "appliance",
    width: 275,
    height: 132
  })))));
};
CallToAction.defaultProps = {
  heading: 'Persönlicher Kontakt',
  description: 'Nehmen Sie Kontakt mit uns auf',
  button: 'Kontakt',
  link: '/kontakt',
  imageFileTitle: 'theme-sonora-call-to-action-background-default'
};
const query = "340886524";
export default CallToAction;